import Full from 'Container/Full'

// calendar components
const Appointments = () => import('Views/calendar/Appointments');

//Posworld components
const DashboardV1 = () => import('Views/dashboard/DashboardV1');

//Klanten
const AdminCustomerLst = () => import('Views/admin/CustomerLst');
const AdminCustomerDet = () => import('Views/admin/CustomerDet');

//Mdewerkers
const AdminUserLst = () => import('Views/admin/UserLst');
const AdminUseryDet = () => import('Views/admin/UserDet');

//Productengamma
const AdminServicesLst = ()  => import('Views/admin/ServiceLst');
const AdminServicesDet = ()  => import('Views/admin/ServiceDet');



//Mail instellingen
const AppMail = () => import('Views/mail/MailAppoint');

//Online reservatie
const SettingsOnlineRes = ()  => import('Views/onlinereservation/OnlineReservationSettings');
const OnlineStructure = ()  => import('Views/onlinereservation/OnlineStructure');
const OnlinePackages = ()  => import('Views/onlinereservation/OnlinePackages');
const OnlinePackageDet = ()  => import('Views/onlinereservation/OnlinePackageDet');
const MigrationOnline = ()  => import('Views/onlinereservation/MigrationOnline');

const HoursUsers = () => import('Views/info/HoursUsers');

export default {
   path: '/',
   component: Full,
   redirect: '/default/customerlst',
   children: [
      //Posworld menu
      {
          path: '/default/mail/appreminder',
          component: AppMail,
          props: {kindmail : 2},
          meta: {
            requiresAuth: true,
            title: 'message.editor_appreminder',
            breadcrumb: 'Mail / herinnering'
          }
      },
      {
        path: '/default/mail/appnew',
        component: AppMail,
        props: {kindmail : 1},
        meta: {
          requiresAuth: true,
          title: 'message.editor_newappoint',
          breadcrumb: 'Mail / herinnering'
        }
      },
      {
        path: '/default/mail/appdelete',
        component: AppMail,
        props: {kindmail : 6},
        meta: {
          requiresAuth: true,
          title: 'message.editor_appdelete',
          breadcrumb: 'Verwijderen afspraak'
        }
      },
      {
        path: '/default/mail/onlineappbasket',
        component: AppMail,
        props: {kindmail : 102},
        meta: {
          requiresAuth: true,
          title: 'Tekst winkelmand',
          breadcrumb: 'Winkelmand bericht'
        }
      },
      {
        path: '/default/onlineres/setttings',
        component: SettingsOnlineRes,
        meta: {
          requiresAuth: true,
          title: 'message.settings',
          breadcrumb: 'Instellingen'
        }
      },
      {
        path: '/default/onlineres/structure',
        component: OnlineStructure,
        meta: {
          requiresAuth: true,
          title: 'Menu',
          breadcrumb: 'Opzet menu'
        }
      },
      {
        path: '/default/calendar/appointments',
        component: Appointments,
        meta: {
          requiresAuth: true,
          title: 'message.agenda',
          breadcrumb: 'Agenda'
        }
      },
      {
        path: '/default/onlineres/packages',
        component: OnlinePackages,
        meta: {
          requiresAuth: true,
          title: 'Online pakketten',
          breadcrumb: 'Pakketten'
        }
      },
      {
        path: '/default/onlineres/migratemenu',
        component: MigrationOnline,
        meta: {
          requiresAuth: true,
          title: 'Menu migratie',
          breadcrumb: 'Online'
        }
      },
      {
        path: '/default/onlineres/packagedet/:id',
        component: OnlinePackageDet,
        name: 'packagedet',
        props: true,
        meta: {
          requiresAuth: true,
          title: 'Detail online pakket',
          breadcrumb: 'Pakketten'
        }
      },
      {
        path: '/default/customerlst',
        name: 'customerlst',
        component:AdminCustomerLst,
        props: {kindrec : 0},
        meta: {
          requiresAuth: true,
          title: 'message.customers',
          breadcrumb: 'Klanten'
        }
      },
      {
        path: '/default/customerdet/:id',
        name: 'customerdet',
        component: AdminCustomerDet,
        props: true,
        meta: {
          requiresAuth: true,
          title: 'message.customerdet',
          breadcrumb: 'Klanten'
        }
      },
      {
        path: '/default/userlst',
        name: 'userlst',
        component:AdminUserLst,
        meta: {
          requiresAuth: true,
          title: 'Medewerkers instellingen',
          breadcrumb: 'Medewerkers'
        }
      },
      {
        path: '/default/userdet/:id',
        name: 'userdet',
        component: AdminUseryDet,
        props: true,
        meta: {
          requiresAuth: true,
          title: 'Medewerkers instellingen',
          breadcrumb: 'Medewerkers'
        }
      },
      {
        path: '/default/info/services',
        component: AdminServicesLst ,
        name: 'servicelst',
        meta: {
           requiresAuth: true,
           title: 'message.services',
           breadcrumb: 'Services'
        }
      },
      {
        path: '/default/articles/servicedet/:id',
        component: AdminServicesDet ,
        name: 'servicedet', 
        props: true,
        meta: {
           requiresAuth: true,
           title: 'message.services',
           breadcrumb: 'Services'
        }
      },
      {
        path: '/default/info/hoursusers',
        name: 'hoursusers',
        component: HoursUsers,
        props: {kindrec : 0},
        meta: {
          requiresAuth: true,
          title: 'Uren medewerkers',
          breadcrumb: 'Uren medewerkers'
        }
      },
      {
        path: '/default/info/hoursshop',
        name: 'hoursshop',
        component: HoursUsers,
        props: {kindrec : 1},
        meta: {
          requiresAuth: true,
          title: 'Uren Shop/ruimtes',
          breadcrumb: 'Uren shop'
        }
      },
     
   ]
}
